import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FoldseekService {
  private _isPDBLoading = signal<any>(false);
  public isPDBLoading = this._isPDBLoading.asReadonly();

  private _isAFDBLoading = signal<any>(false);
  public isAFDBLoading = this._isAFDBLoading.asReadonly();

  private _isStructureRunning = signal<any>(false);
  public isStructureRunning = this._isStructureRunning.asReadonly();

  private _hasPDBData = signal<any>(-1);
  public hasPDBData = this._hasPDBData.asReadonly();

  private _hasAFDBData = signal<any>(-1);
  public hasAFDBData = this._hasAFDBData.asReadonly();

  private _isStructureFail = signal<any>(false);
  public isStructureFail = this._isStructureFail.asReadonly();

  private _isAFDBFoldseekCach = signal<any>(true);
  public isAFDBFoldseekCach = this._isAFDBFoldseekCach.asReadonly()

  private _isPDBFoldseekCach = signal<any>(true);
  public isPDBFoldseekCach = this._isPDBFoldseekCach.asReadonly();


  private _isStructureCach = signal<any>(true);
  public isStructureCach = this._isStructureCach.asReadonly();

  private _totalAllBacteria = signal<any>(0);
  public totalAllBacteria = this._totalAllBacteria.asReadonly();

  private _totalBFVD = signal<any>(0);
  public totalBFVD = this._totalBFVD.asReadonly();

  private _totalNTDX = signal<any>(0);
  public totalNTDX = this._totalNTDX.asReadonly();

  private _totalVIRO = signal<any>(0);
  public totalVIRO = this._totalVIRO.asReadonly();

  private _totalVAD = signal<any>(0);
  public totalVAD = this._totalVAD.asReadonly();

//   private _isPDBDownloadEnabled = signal<any>(null);
//   public isPDBDownloadEnabled = this._isPDBDownloadEnabled.asReadonly();
  
//   private _isAFDBDownloadEnabled = signal<any>(null);
//   public isAFDBDownloadEnabled = this._isAFDBDownloadEnabled.asReadonly();
  
 
//   public isStructureCach = linkedSignal({
//     source: this.subcomplexInteractions,
//     computation: () => this._isAFDBFoldseekCach() && this._isPDBFoldseekCach(),
//   });

  public updateIsPDBLoading(data:boolean){
    this._isPDBLoading.set(data);
  }

  public updateIsAFDBLoading(data:boolean){
    this._isAFDBLoading.set(data);
  }

  public updateStructureRunning(data:boolean){
    this._isStructureRunning.set(data);
  }

  public updateHasPDBData(data:number){
    this._hasPDBData.set(data);
  }


  public updateHasAFDBData(data:number){
    this._hasAFDBData.set(data);
  }

  public updateIsStructureFail(data:boolean){
    this._isStructureFail.set(data);
  }

  public updateIsAFDBFoldseekCach(data:boolean){
    this._isAFDBFoldseekCach.set(data);
  }

  public updateIsPDBFoldseekCach(data:boolean){
    this._isPDBFoldseekCach.set(data);
  }

  public updateIsStructureCach(data:boolean){
    this._isStructureCach.set(data);
  }

  public updateTotalAllBacteria(data:any){
    this._totalAllBacteria.set(data);
  }

  public updateTotalBFVD(data:any){
    this._totalBFVD.set(data);
  }

  public updateTotalNTDX(data:any){
    this._totalNTDX.set(data);
  }

  public updateTotalVIRO(data:any){
    this._totalVIRO.set(data);
  }

  public updateTotalVAD(data:any){
    this._totalVAD.set(data);
  }

    //   public updateIsAFDBDownloadEnabled(data:boolean){
    //     this._isAFDBDownloadEnabled.set(data);
    //   }
}
